var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBilling = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 25 25"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 20,
  x: 4.273,
  y: 2.378,
  stroke: "currentColor",
  rx: 4
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 8,
  height: 3,
  x: 8.273,
  y: 6.378,
  stroke: "currentColor",
  rx: 1
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  d: "M9.273 18.378h-1M9.273 14.378h-1M15.273 18.378h1M15.273 14.378h1"
})));
export default SvgBilling;